import { Styles } from 'const';
import { createTextStyles } from 'factories/style';
import * as Models from 'models';
import { isDefaultBrandStyleAvailable } from 'utils/brandStyles';
import { applyBrandStyleOnRelation } from './applyBrandStyleOnRelation';

export function createStylesWithDefaultBrandStyle(
  sectionStyles: Models.MasterScreen.SectionStylesMap,
  styles: Models.BrandStylesMap,
  colors: Models.BrandColorsList,
  fonts: Models.BrandFontsList,
): Models.TextRelationStyles {
  if (!sectionStyles || !styles || !colors || !fonts || !isDefaultBrandStyleAvailable(styles, sectionStyles)) {
    return createTextStyles();
  }

  const partialStyle = applyBrandStyleOnRelation(
    {} as Models.TextRelationStyles,
    { brandStyle: styles.get(Styles.DefaultTextBrandStyle), fonts, colors },
  );

  return createTextStyles(partialStyle);
}
